module.exports = __webpack_public_path__ + "media/images/text-bg-62db8198e803940c3ffe267d7ef663e8.svg";